export enum TransportCompanyAvailableType {
    EVERYWHERE = 0,
    ONLY_ACCOUNTING = 1
} 